/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

(function ($) {

	// Use this variable to set up the common and page specific functions. If you
	// rename this variable, you will also need to rename the namespace below.
	var Sage = {
		/* REVEAL ITEM UPON VIEW */
		// Declared here to use in multiple name spaces
		'itemReveal': function() {
			var waypoints = $('.reveal').waypoint({
			  	handler: function(direction) {
					$(this).addClass('revealed');
			  	},
				  offset: '90%'
			}); 
		},
		/* END REVEAL ITEM UPON VIEW */

		// All pages
		'common': {
			init: function () {
				// JavaScript to be fired on all pages

				/** GLOBAL VARIABLES */
				var body = document.querySelector('body');
				/** END GLOBAL VARIABLES */


				/** SKIP LINK NAVIGATION */
				$('#skip-to-content').click(function (event) {
					// strip the leading hash and declare
					// the content we're skipping to
					var skipTo = "#" + this.href.split('#')[1];
					// Setting 'tabindex' to -1 takes an element out of normal 
					// tab flow but allows it to be focused via javascript
					$(skipTo).attr('tabindex', -1).on('blur focusout', function () {
						// when focus leaves this element, 
						// remove the tabindex attribute
						$(this).removeAttr('tabindex');
					}).focus(); // focus on the content container
				});
				/** END SKIP LINK NAVIGATION */

				// HOVER INTENT
				$("#menu-main-menu > .menu-item-has-children").hoverIntent(function() {
					$(this).children(".sub-menu").fadeIn(600);
					$(this).addClass('menu-item--hover');
					$('.header').addClass('header--mouse-over');
				}, function() {
					$(this).children(".sub-menu").fadeOut(300);
					$(this).removeClass('menu-item--hover');
					$('.header').removeClass('header--mouse-over');
				}, 750);


				/* HEADER SCROLL EFFECT */
				// Reference: http://tympanus.net/codrops/2013/06/06/on-scroll-animated-header/
				var animatedHeader = (function () {
					var didScroll = false,
						scrollOffset = 0;
					function scrollY() {
						return window.pageYOffset || document.documentElement.scrollTop;
					}
					function scrollPage() {
						var sy = scrollY();
						if (sy > scrollOffset) {
							body.classList.add('scroll-triggered');
						}
						else {
							body.classList.remove('scroll-triggered');
						}
						didScroll = false;
					}
					function init() {
						window.addEventListener('load', scrollPage);
						window.addEventListener('scroll', function (event) {
							if (!didScroll) {
								didScroll = true;
								setTimeout(scrollPage, 250);
							}
						}, false);
					}
					init();
				})();
				/* END HEADER SCROLL EFFECT */

				/** RESPONSIVE NAV OPEN/CLOSE **/
				var mobileNav = document.querySelector('#mobile-nav');
				var mobileNavButton = document.querySelector('#mobile-nav-icon');

				// Toggle menu icon
				if (mobileNavButton) {
					mobileNavButton.addEventListener('click', function () {
						body.classList.toggle('mobile-nav-open');
					});
				}

				// Close menu if page is clicked (not menu item)
				if (mobileNav) {
					mobileNav.addEventListener('click', function (e) {
						// Don't hide if click is on a child element (nav link)
						if (e.target !== this) {
							return;
						}
						mobileNavButton.classList.toggle('opened');
						$("#nav-toggle").prop('checked', false);
					});

					// Disable click on mobile
					$("#mobile-nav .menu-item-has-children > .sub-menu--open").on("click", function () {
						$(this).parent().toggleClass("mobile-nav--opened");
					});
				}
				/** END RESPONSIVE NAV OPEN/CLOSE **/

				// Starts item reveal JS
				Sage.itemReveal();

				/** SHOW AND HIDE SEARCH BAR **/
				var searchButton = $('#search-button'),
					headerSearch = $('#header-search'),
					searchClose  = $('#search-close');

				searchButton.click(function () {
					headerSearch.fadeToggle('slow', function() {
						if ((window.ActiveXObject) && !("ActiveXObject" in window)) {
							headerSearch.find('input[type="text"]').focus();
						}
					});
					return false;
				});
				searchClose.click(function () {
					headerSearch.fadeToggle('fast');
				});

				// Shake Animation
				function shake(div) {
					var interval = 100;
					var distance = 10;
					var times    = 4;

					$(div).css('position', 'relative');
					for (var iter = 0; iter < (times + 1); iter++) {
						$(div).animate({ left: ((iter % 2 === 0 ? distance : distance * -1)) }, interval);
					}
					$(div).animate({ left: 0 }, interval);
				}

				// Search Submit
				headerSearch.submit(function (e) {
					var s = $(this).find('input[type="text"]');
					if (!s.val()) {
						e.preventDefault();
						shake($(this).find('input[type="text"]'));
						$(this).find('input[type="text"]').focus();
					}
				});
				/** END SHOW OR HIDE SEARCH BAR **/


				/** MASTHEAD PRGRESSIVE IMAGES **/
				var masthead = document.querySelector('.masthead'),
					placeholderOverlay = document.querySelector('.placeholder-overlay');

				if (masthead && placeholderOverlay) {
					// Load full size image. When loaded, fade our placeholder add it as bg to masthead
					var img = new Image();
					img.src = masthead.dataset.imageSrc;
					img.onload = function () {
						placeholderOverlay.classList.add('fade-out');
						masthead.style.backgroundImage = "url(" + img.src + ")";
					};
				}
				/** END MASTHEAD PRGRESSIVE IMAGES **/


				/** ANIMATED ANCHOR LINKS **/
				$('a[href*="#"]:not([href="#"])').click(function (e) {
					if (location.pathname.replace(/^\//, '') === this.pathname.replace(/^\//, '') && location.hostname === this.hostname) {
						var target            = $(this.hash);
						var $this             = this;
						var header            = $('.header');
						var wpAdminBar        = $('#wpadminbar');
						var fixedHeaderOffset = parseInt(header.outerHeight()) - parseInt(header.css("padding-top").replace("px", ""));

						if ( wpAdminBar.length ) { // If we're logged in and WP Admin Bar exists, add it to the offset
							fixedHeaderOffset += parseInt(wpAdminBar.outerHeight());
						}

						target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
						if (target.length) {
							$('html,body').animate({
								scrollTop: (target.offset().top - fixedHeaderOffset)
							}, 500, function () {
								if (history.pushState) {
									history.pushState(null, null, $this.hash);
								}
								else {
									location.hash = $this.hash;
								}
							});
							e.preventDefault();
						}
					}
				});
				/** END ANIMATED ANCHOR LINKS **/

				/* NUMBER TICKER UPON VIEW */
				// IMPORTANT: Requires Waypoint.js and Counterup.js (Enqueued from JSDelivr)
				var numberTickers = $('.ticker');
				if (numberTickers.length) {
					numberTickers.counterUp({
						time: 700
					});
				}
				/* END NUMBER TICKER UPON VIEW */

				/* SLIDER */
				// Default sliders using slick.js
				if ($('.slider').length > 0 ) {
					var slider = $('.slider > .vc_row > .wpb_column > .vc_column-inner > .wpb_wrapper');
					slider.slick({
						autoplay      : true,
						autoplaySpeed : 5000,
						infinite      : true,
						centerMode    : true,
						centerPadding : '0px',
						cssEase       : 'linear',
						// slide 		  : '.vc_inner',
						slidesToShow  : 1,
						slidesToScroll: 1,
						swipeToSlide  : true,
						dots          : true,
						arrows        : true,
						fade          : true,
						mobileFirst   : true,
						prevArrow 	  : '<button type="button" class="slick-prev"><span class="icon-chevron-left"></span></button>',
						nextArrow 	  : '<button type="button" class="slick-next"><span class="icon-chevron-right"></span></button>',
					});
				}

				/* READ MORE */
				// Expandable content onclick
				function expandableContent() {
					// The ideal stacking order for these elements is:
					//	.read-more__initial - Content displayed initially
					//	.read-more__expand - Content to be displayed
					//	.read-more__button - Button to toggle content display
					var expandInitial = $('.read-more__initial');
					var expandContent = $('.read-more__expand');
					var expandButton  = $('.read-more__button button');

					expandButton.click(function(){
						var txt = expandInitial.hasClass('read-more--expanded') ? 'Show More <span class="icon-chevron-down"></span>' : 'Show Less <span class="icon-chevron-up"></span>';
						$(this).html(txt);
						expandContent.slideToggle(400);
						expandInitial.toggleClass('read-more--expanded');
					});
				}

				expandableContent();

			},
			finalize: function () {
				// JavaScript to be fired on all pages, after page specific JS is fired
			}
		},

		// Home page
		'home': {
			init: function () {
				// JavaScript to be fired on the home page
				// $(window).load(function(){
				// 	$('body').addClass('page--animated');
				// });

				/* SLIDER */
				// Default sliders using slick.js
				if ($('#slider').length > 0 ) {
					var slider = $('#slider .slider__container');
					
					slider.on('init', function(slick){
						$('body').addClass('page--animated');
					});

					slider.slick({
						autoplay      : true,
						autoplaySpeed : 8000,
						infinite      : true,
						centerMode    : true,
						centerPadding : '0px',
						cssEase       : 'linear',
						slidesToShow  : 1,
						slidesToScroll: 1,
						swipeToSlide  : true,
						dots          : true,
						arrows        : false,
						fade          : true,
						mobileFirst   : true,
						pauseOnHover  : false
					});

					// If there are slide controls (more than one slide controlled in php)
					if ($('#slide-controls').length) {
						var $currentControl = $('.slider__control').first();
						// Adds current-control class to first control
						$currentControl.addClass('current-control');
						var $currentControlWidth = $currentControl.outerWidth();
						var $currentControlLeft  = $currentControl.position().left;
						
						// Listens on each control
						$('.slider__control').each(function(){
							var $this = $(this);
							var index = $this.data('index');

							// On a control click
							$this.on('click', function(){

								// Remove all current-control classes and add it to clicked control
								$('.slider__control').removeClass('current-control');
								$(this).addClass('current-control');
								$currentControlWidth = $(this).outerWidth() + 40;
								$currentControlLeft  = $(this).position().left;

								// Hook into Slick's method to go to corresponding slide
								slider.slick('slickGoTo', index);
							});
						});

						// Moves magic line when Slick auto moves slides
						slider.on('beforeChange', function(event, slick, currentSlide, nextSlide){
							// Remove all current-control classes and add it to clicked control
							$('.slider__control').removeClass('current-control');
							$(".slider__control[data-index='" + nextSlide + "']").addClass('current-control');
							$currentControlWidth = $('.current-control').outerWidth();
							$currentControlLeft  = $('.current-control').position().left;
						});
					}
				}
				/* END PROGRAM SLIDER */
			},
			finalize: function () {
				// JavaScript to be fired on the home page, after the init JS
			}
		},

		// About us page, note the change from about-us to about_us.
		'about_us': {
			init: function () {
				// JavaScript to be fired on the about us page
			}
		},
		// Sub Nav Landing Page Template - For AJAX page loading
		'project_template_template_sub_nav_landing': {
			
			init: function () {

				// Cancel this on Restorative Justice Diversion - this page emulates the Restorative Justice menu,
				// but should not function the same.
				if( $('#menu-restorative-justice-diversion').length > 0 ) return;

				// JavaScript to be fired on the Program Template pages
				var sectionLinks = $(".ajax-sub-nav a");
				var overviewHref = sectionLinks.first().attr("href");
				var ajaxContent  = $("#ajax-content");

				// Set first link to active
				sectionLinks.first().addClass("active-link");

				// This function is taken from WP Bakery Page Builder
				// It expands out full width rows when loaded in via ajax
				function fullWidthRow() {
					var $elements = $('[data-vc-full-width = "true"]');
					$.each($elements, function(key, item) {
						var $el      = $(this);
						$el.addClass("vc_hidden");
						var $el_full = $el.next(".vc_row-full-width");
						if (
							($el_full.length ||
							($el_full = $el.parent().next(".vc_row-full-width")),
							$el_full.length)
						) {
							var el_margin_left = parseInt($el.css("margin-left"), 10),
							el_margin_right    = parseInt($el.css("margin-right"), 10),
							offset             = 0 - $el_full.offset().left - el_margin_left,
							width              = $(window).width();
							if (
							($el.css({
								position    : "relative",
								left        : offset,
								"box-sizing": "border-box",
								width       : $(window).width()
							}),
							!$el.data("vcStretchContent"))
							) {
							var padding = -1 * offset;
							0 > padding && (padding = 0);
							var paddingRight =
								width -
								padding -
								$el_full.width() +
								el_margin_left +
								el_margin_right;
							0 > paddingRight && (paddingRight = 0),
								$el.css({
								"padding-left": padding + "px",
								"padding-right": paddingRight + "px"
								});
							}
							$el.attr("data-vc-full-width-init", "true"),
							$el.removeClass("vc_hidden"),
							$(document).trigger("vc-full-width-row-single", {
								el         : $el,
								offset     : offset,
								marginLeft : el_margin_left,
								marginRight: el_margin_right,
								elFull     : $el_full,
								width      : width
							});
						}
					}),
					$(document).trigger("vc-full-width-row", $elements);
				}

				// Reinitialize expanded content
				function expandableContent() {
					var expandInitial = $('.read-more__initial');
					var expandContent = $('.read-more__expand');
					var expandButton  = $('.read-more__button button');

					expandButton.click(function(){
						var txt = expandInitial.hasClass('read-more--expanded') ? 'Show More' : 'Show Less';
						$(this).text(txt);
						expandContent.slideToggle(400);
						expandInitial.toggleClass('read-more--expanded');
					});
				}

				// Toggle FAQs
				function toggleFaqs() {
					$('.vc_toggle_title').on('click', function(){
						// Toggle for FAQs
						var title    = $(this),
							element  = title.closest(".vc_toggle"),
							content  = element.find(".vc_toggle_content");

						if( element.hasClass("vc_toggle_active") ) {
							content.slideUp({
								duration: 300,
								complete: function() {
									element.removeClass("vc_toggle_active")
								}
							});
						} else {
							content.slideDown({
								duration: 300,
								complete: function() {
									element.addClass("vc_toggle_active")
								}
							});
						}
					});
				}

				// Toggle display of all sections within #ajax-content,
				// including initially hidden .vc_section
				function emulateAjax() {
					$('.vc_section--ajax').on('click', function(e) {
						e.preventDefault();

						var url     = $(this).attr("href"); // Full URL
						var section = $(url); // NON-AJAX hidden section on page
						if( section.length ) {
							$("#ajax-content > div > .vc_section").toggleClass("vc_section--hidden", function(){
								$(this).fadeToggle("slow");
							});
						}
					});
				}

				emulateAjax();

				// Actions fired on each submenu item click
				sectionLinks.on('click', function (e) {

					// If the currently active link matches the clicked link, don't do anything
					// (don't reload content that's already loaded)
					if( $(this).hasClass("active-link") ) {
						e.preventDefault();
						return;
					}
					
					var hash    = ' ';
					var url     = $(this).attr("href"); // Full URL
					var key     = url.match(/\/([^\/]+)\/?$/)[1]; // Last part of the URL (after the last /)
					var first   = url.match(/\/([^\/]+)\/?$/); // First part of the URL (before the last /something)
					var match   = url.replace(first[0], '') + '/';
					var section = $(key); // NON-AJAX hidden section on page

					if( match == overviewHref ) {
						var hash = "#" + key; // Add a hash and key to the current URL
					}

					// For hidden sections, first look to see if the key matches an existing section on the page.
					// If so, hide current ajax-content and display the hidden section
					if( section.length ) {
						// Add active to clicked nav items
						sectionLinks.removeClass('active-link');
						$(this).addClass('active-link');

						// This will toggle display of all sections within #ajax-content,
						// including initially hidden .vc_section
						ajaxContent.find('.vc_section').fadeToggle("slow", function(){
							$(this).toggleClass('vc_section--hidden');
						});
					}

					// If the first part of the full URL clicked (url) matches the first part of the overview URL (overview), do ajax
					// Otherwise, do not adjust link behavior
					if( match == overviewHref || url == overviewHref ) {
						e.preventDefault();

						// Add active to clicked nav items
						sectionLinks.removeClass('active-link');
						$(this).addClass('active-link');
					
						history.replaceState(null, null, hash); // modifies the current history entry

						// Fetch section content and add to current page
						$.ajax({
							url: url,
							beforeSend: function(){
								ajaxContent.addClass('loading');
							},
							success: function (data) {
								data = $.parseHTML(data);
								// Get custom styles created via page builder
								customStyles = $(data).filter('style[data-type="vc_shortcodes-custom-css"]');
								// get the html content we want to use to replace current content
								ajaxReplacement = $(data).find('#ajax-content > div');
								// If there are custom styles, add them to the end of the head
								if (customStyles) {
									$("head").append(customStyles);
								}
								// Empty current content and replace with fetched content
								ajaxContent.empty();
								ajaxContent.html(ajaxReplacement);

								// Toggle FAQs
								toggleFaqs();
	
								// Relative Page Builder events
								expandableContent();
								fullWidthRow();
								
								// slick.js
								if ($('.slider').length > 0 ) {
									var slider = $('.slider > .vc_row > .wpb_column > .vc_column-inner > .wpb_wrapper');
									slider.slick({
										autoplay      : true,
										autoplaySpeed : 5000,
										infinite      : true,
										centerMode    : true,
										centerPadding : '0px',
										cssEase       : 'linear',
										slidesToShow  : 1,
										slidesToScroll: 1,
										swipeToSlide  : true,
										dots          : true,
										arrows        : true,
										fade          : true,
										mobileFirst   : true,
										prevArrow 	  : '<button type="button" class="slick-prev"><span class="icon-chevron-left"></span></button>',
										nextArrow 	  : '<button type="button" class="slick-next"><span class="icon-chevron-right"></span></button>',
									});
								}

								var waypoints = $('.reveal').waypoint({
									handler: function(direction) {
									$(this).addClass('revealed');
									},
									offset: '90%'
								});

								// Also for consideration is loading relative page builder js assets for respective elements.
								// For example, accordions call vc-accordion.min.js
								// How to: scrub through elements on load (ajax) and load
								$('.vc_section--ajax').on('click', function(e) {
									e.preventDefault();
			
									var url     = $(this).attr("href"); // Full URL
									var section = $(url); // NON-AJAX hidden section on page
			
									if( section.length ) {										
										$("#ajax-content > div > .vc_section").fadeToggle("slow", function(){
											$(this).toggleClass('vc_section--hidden');
										});
									}
								});

							},
							complete: function(){
								ajaxContent.removeClass('loading');
							}
						});

					}

				});

				// If the page loads with a hash, fetch that section
				if (window.location.hash) {
					var target = '';
					// Get just the hash part of the url
					var key = window.location.hash.slice(1);

					// Go through each sub nav links
					$('.ajax-sub-nav a').each(function() {
						// Get it's href url
						var subNavUrl = $(this).attr("href");
						// Get the last part of the url (after the last /)
						var subNavUrlEnd = subNavUrl.match(/\/([^\/]+)\/?$/)[1];
						// If this matches the hash (key), set this url to the url we will use to fetch content via AJAX
						if (subNavUrlEnd === key) {
							url = subNavUrl;

							sectionLinks.removeClass('active-link');
							$(this).addClass('active-link');
					

							// If we have a valid url
							if (url.length) {
								// Go getch the content via AJAX
								$.ajax({
								url: url,
									success: function (data) {
										data = $.parseHTML(data);
										// Get custom styles created via page builder
										customStyles = $(data).filter('style[data-type="vc_shortcodes-custom-css"]');
										// get the html content we want to use to replace current content
										ajaxReplacement = $(data).find('#ajax-content > div');
										// If there are custom styles, add them to the end of the head
										if (customStyles) {
											$("head").append(customStyles);
										}
										// Empty current content and replace with fetched content
										ajaxContent.empty();
										ajaxContent.html(ajaxReplacement);

										expandableContent();
										fullWidthRow();

										// Toggle FAQs
										toggleFaqs();

										var waypoints = $('.reveal').waypoint({
											handler: function(direction) {
												$(this).addClass('revealed');
											},
											offset: '90%'
										});
									}
								});
							}
						}
					});
				}
				
			}
		}
	};

	// The routing fires all common scripts, followed by the page specific scripts.
	// Add additional events for more control over timing e.g. a finalize event
	var UTIL = {
		fire: function (func, funcname, args) {
			var fire;
			var namespace = Sage;
			funcname = (funcname === undefined) ? 'init' : funcname;
			fire = func !== '';
			fire = fire && namespace[func];
			fire = fire && typeof namespace[func][funcname] === 'function';

			if (fire) {
				namespace[func][funcname](args);
			}
		},
		loadEvents: function () {
			// Fire common init JS
			UTIL.fire('common');

			// Fire page-specific init JS, and then finalize JS
			$.each(document.body.className.replace(/-/g, '_').split(/\s+/), function (i, classnm) {
				UTIL.fire(classnm);
				UTIL.fire(classnm, 'finalize');
			});

			// Fire common finalize JS
			UTIL.fire('common', 'finalize');
		}
	};

	// Load Events
	$(document).ready(UTIL.loadEvents);

})(jQuery); // Fully reference jQuery after this point.
